<template>
  <ubi-panel>
    <ubi-form-group :title="$t('posts.isolationThermiqueSolaireTitle')">
      <el-row :gutter="20">
        <el-col :lg="9">
          <el-form-item :label="$labels.isolation_thermique_valeur"
                        prop="isolation_thermique_valeur">
            <el-input v-model.number="post.isolation_thermique_valeur" type="number">
              <template slot="append">kWh/m²/an</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="14">
          <el-form-item>
            <div style="font-size: 12px;">{{ $labels.isolation_thermique_classe }}
              <el-button class="el-icon-error reset-radio"
                         v-if="post.isolation_thermique_classe != '' && post.isolation_thermique_classe != undefined && post.isolation_thermique_classe != null"
                         @click="post.isolation_thermique_classe = null"
                         circle></el-button>
            </div>
            <el-radio-group v-model="post.isolation_thermique_classe">
              <el-radio
                v-for="classeChoice in classeChoices"
                :key="classeChoice"
                :label="classeChoice"
                :value="classeChoice">
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="12">
          <el-form-item :label="$labels.panneaux_solaires" prop="panneaux_solaires">
            <el-radio v-model="post.panneaux_solaires" label="oui">{{ $t("general.yes") }}</el-radio>
            <el-radio v-model="post.panneaux_solaires" label="non">{{ $t("general.no") }}</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
    </ubi-form-group>
  </ubi-panel>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import UbiPanel from '../../../../components/Panel.vue'
import UbiFormGroup from '@/components/forms/FormGroup.vue'

export default {
  name: 'IsolationThermiqueSolaire',
  components: { UbiFormGroup, UbiPanel },
  props: ['post'],
  data () {
    return {
      classeChoices: []
    }
  },
  methods: {
    getListedValues (list, code) {
      if (!list || list.type === 'error' || !list.length) {
        return []
      }
      const dd = list.find(function (item) {
        return item.code === code
      })
      if (dd && dd.values) {
        return dd.values
      }
      return []
    }
  },
  async beforeMount () {
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({
      codes: ['ISOLATION_THERMIQUE_CLASSE']
    })
    this.classeChoices = this.getListedValues(
      definitionDonneeListeeByCode,
      'ISOLATION_THERMIQUE_CLASSE'
    )
  }
}
</script>
